import { render, staticRenderFns } from "./PasswordResetRequest.vue?vue&type=template&id=1ec9546b&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetRequest.vue?vue&type=style&index=0&id=1ec9546b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9546b",
  null
  
)

export default component.exports